/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Blocked_TitleInputs */



/**
* | output |
* | --- |
* | "This meeting does not admit the notetaker" |
*
* @param {Meeting_Notetaker_Issue_Blocked_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_blocked_title = /** @type {((inputs?: Meeting_Notetaker_Issue_Blocked_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Blocked_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Deze meeting laat de notetaker niet toe")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette réunion n'admet pas le notetaker")
	return /** @type {LocalizedString} */ ("This meeting does not admit the notetaker")
});